<template>
<!-- v-if="!noForm && localList" -->
  <component :is="el"  :label="label" :prop="prop" :required="required">

    <span v-if="noForm && showLabel">{{label}}</span>

    <el-select
      v-if="!disabled || showSelectDisabled"
      v-model="formData"
      :placeholder="placeholder"
      :size="size"
      :filterable="filterable"
      :allow-create="create"
      :disabled="disabled"
      :clearable="clearable"
      :no-data-text="noDataText"
      @change="updated">

        <template #prefix>

          <img v-if="(imageProp && form && form[imageProp]) || isImageList"
              class="prefix"
              :src="isImageList ? form[labelValue] : form[imageProp]">

        </template>
<!-- @BUG on RTA images -->
        <el-option
          v-if="item[valueKey]"
          v-for="(item, i) in localList" :key="item[valueKey]"
          :value="item">

          <img v-if="(imageProp && item[imageProp]) || isImageList"
              :src="isImageList ? item[valueKey] : item[imageProp]">

          <span v-if="!isImageList"><i v-if="hasIcon(i)" :class="getIcon(i)">&nbsp;</i>{{item[labelValue]}}</span>

        </el-option>

  </el-select><!-- XOL-596: optional trailing slot INSIDE the form item (the request drawer's "changed underneath you" cue); nothing renders when unused. No whitespace before it, so the unused markup is unchanged. --><slot name="cue"></slot>

</component>
</template>

<script>

export default {
  name: 'select-input',

  props: {
    label: {
      type: String,
      default: ''
    },

    value: {
      required: true
    },

    labelValue: {
      type: String,
      default: 'label'
    },

    valueKey: {
      type: String,
      default: 'value'
    },

    list: {
      type: Array,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    size: {
      type: String,
      default: 'default'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showSelectDisabled: {
      type: Boolean,
      default: true
    },

    filterable: {
      type: Boolean,
      default: false
    },

    create: {
      type: Boolean,
      default: false
    },

    isImageList: {
      type: Boolean,
      default: false
    },

    imageProp: {
      type: String,
      default: 'image'
    },

    imageList: {
      type: Array,
      default: null
    },

    iconProp: {
      type: String,
      default: 'icon'
    },

    iconList: {
      type: Array,
      default: null
    },

    returnObject: {
      type: Boolean,
      default: false
    },

    returnList: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    noForm: {
      type: Boolean,
      default: false
    },

    showLabel: {
      type: Boolean,
      default: true
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    clearable: {
      type: Boolean,
      default: false
    },

    noDataText: {
      type: String,
      default: null
    }
  },

  methods: {
    init () {

      if (!this.list) {
        return
      }

      if (this.list.length > 0 && !this.list[0][this.value] && !this.isJsObject(this.list[0])) {

        for (let i = 0; i < this.list.length; i++) {
          let obj = {}
          obj[this.labelValue] = this.list[i]
          obj[this.valueKey] = this.list[i]

          if (this.hasImage(i)) {
            obj[this.imageProp] = this.getImage(i)
          }

          this.localList.push(obj)
        }

      } else {
        this.localList = this.list
      }

    },


    hasIcon (ind) {
      return this.findImageIcon(ind, this.iconList, this.iconProp)
    },


    getIcon (ind) {
      return this.findImageIcon(ind, this.iconList, this.iconProp, true)
    },


    hasImage (ind) {
      return this.findImageIcon(ind, this.imageList, this.imageProp)
    },


    getImage (ind) {
      return this.findImageIcon(ind, this.imageList, this.imageProp, true)
    },



    /**
      @param {int} ind - index into arr
      @param {array} arr - Pirate Arr!
      @param {string} prop - prop in list
      @param {boolean} returnItem if true returns item / boolean

      If the image/icon array isn't the same length has list, false
      will be returned.

      @return {object/boolean} - if returnItem is false boolean, else object
     */
    findImageIcon (ind, arr = null, prop = null, returnItem = false) {

      let item = null

      if (this.isArray(arr)) {

        // FIXME pre-existing tautology surfaced by ESLint 7 (XOL-104 PR-2).
        // Intent was likely `arr.length > ind` bounds check; currently always true.
        // eslint-disable-next-line no-self-compare
        if (arr.length === arr.length) {
          item = arr[ind]
        }

      } else {

        if (prop) {
          item = this.list[ind][prop]
        }

      }

      return (returnItem ? item : (item ? true : false))
    },


    updated (value) {
      this.form = value
      this.formData = (this.returnObject ? value : value[this.valueKey])

      if (this.create) {
        this.localList.push(value)
      }

      this.$emit('input', this.returnList ? this.localList : (this.returnObject ? this.form : this.form[this.valueKey]))
      this.$emit('change', this.returnList ? this.localList : (this.returnObject ? this.form : this.form[this.valueKey]))
    }
  },

  data () {
    return {
      el: this.noForm ? 'div' : 'el-form-item',
      form: {},
      formData: this.value,
      localList: []
    }
  },


  mounted () {
    this.init()
  }
}
</script>

<style scoped>
.el-select {width: 100%}

img {
  width: 20px;
  height: 20px;
}

.prefix {
  margin-top: 10px;
}

</style>
